var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.401 2.25a6.25 6.25 0 0 0-4.42 1.832l-.53.53-.53-.53a6.251 6.251 0 1 0-8.84 8.84l8.84 8.84a.75.75 0 0 0 1.06 0l8.84-8.84a6.25 6.25 0 0 0-4.42-10.672m-4.95 17.921-8.31-8.31a4.751 4.751 0 1 1 6.72-6.719l1.06 1.06a.75.75 0 0 0 1.06 0l1.06-1.06a4.75 4.75 0 1 1 6.72 6.72l-1.06 1.06z",
  clipRule: "evenodd"
})));
export default SvgHeart;